import {
  ApiResidenceValueProperty,
  ApiResidenceValuePropertyInformation,
  ApiResidenceValuePropertyValue
} from '../../../../../@types';
import { createContext, FC, ReactNode, useState } from 'react';
import { ResidenceType } from '../config';

export interface HomeValueContextType {
  property: ApiResidenceValueProperty;
  propertyInformation: ApiResidenceValuePropertyInformation;
  propertyValue: ApiResidenceValuePropertyValue;
  selectedResidenceType: ResidenceType;
  selectedResidenceTypeLabel: string;
  setProperty: (property: ApiResidenceValueProperty) => void;
  setPropertyInformation: (propertyInformation: ApiResidenceValuePropertyInformation) => void;
  setPropertyValue: (propertyValue: ApiResidenceValuePropertyValue) => void;
  setSelectedResidenceType: (selectedResidenceType: ResidenceType) => void;
  setSelectedResidenceTypeLabel: (setSelectedResidenceTypeLabel: string) => void;
}

export const HomeValueContext = createContext<HomeValueContextType>({
  property: {} as ApiResidenceValueProperty,
  propertyInformation: {} as ApiResidenceValuePropertyInformation,
  propertyValue: {} as ApiResidenceValuePropertyValue,
  selectedResidenceType: 'Appartement',
  selectedResidenceTypeLabel: '',
  setProperty: () => {
    throw new Error('setProperty function must be overridden');
  },
  setPropertyInformation: () => {
    throw new Error('setPropertyInformation function must be overridden');
  },
  setPropertyValue: () => {
    throw new Error('setPropertyValue function must be overridden');
  },
  setSelectedResidenceType: () => {
    throw new Error('setSelectedResidenceType function must be overridden');
  },
  setSelectedResidenceTypeLabel: () => {
    throw new Error('setSelectedResidenceTypeLabel function must be overridden');
  }
});

export const HomeValueProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [property, setProperty] = useState<ApiResidenceValueProperty>(
    {} as ApiResidenceValueProperty
  );
  const [propertyInformation, setPropertyInformation] =
    useState<ApiResidenceValuePropertyInformation>({} as ApiResidenceValuePropertyInformation);
  const [propertyValue, setPropertyValue] = useState<ApiResidenceValuePropertyValue>(
    {} as ApiResidenceValuePropertyValue
  );
  const [selectedResidenceType, setSelectedResidenceType] = useState<ResidenceType>('Appartement');
  const [selectedResidenceTypeLabel, setSelectedResidenceTypeLabel] = useState<string>('');

  return (
    <HomeValueContext.Provider
      value={{
        property,
        propertyInformation,
        propertyValue,
        selectedResidenceType,
        selectedResidenceTypeLabel,
        setProperty,
        setPropertyInformation,
        setPropertyValue,
        setSelectedResidenceType,
        setSelectedResidenceTypeLabel
      }}>
      {children}
    </HomeValueContext.Provider>
  );
};
